import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";  
import playIcon from "../../assets/play-icon.svg";
import {
  PlayIcon
} from "../MasterCss";
const OptionsBox = styled.div`
  background-color: #08345c;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  position: fixed;
  top: 0;
  left: 0;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 25px;
  padding-bottom: 25px;
  z-index: 2000;
  margin: 0;
  border-radius: 0 0 25px 0;
`;


const OptionsList = styled.ul`
  list-style-type: none;
  margin-left: 7vh;
  padding: 0;
  @media (max-width: 480px) {
    margin-top: 4vh;
    margin-left: 3vh;
  }
`;

const OptionsListItem = styled.li`
  font-family: Signika;
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  align-items: center;
  color: #ffffff;
  text-decoration: none;
  cursor: pointer;
  line-height: 2.2rem;
  @media (max-width: 480px) {
    font-size: 1.2rem;
    line-height: 1.7rem;
  }
  &:hover {
    text-decoration: underline;
  }
`;

const OptionsModal = props => {
  const { t } = useTranslation();  
  const hideOptionsModal = () => {
    props.setOptionsModal(!props.optionsModal);
  };

  const navigate = useNavigate();

  const quitGame = () => {
    props.setCount(0);
    props.setBadCount(0);
    props.setGame(null);
    navigate("/");
  };

  return (
    <OptionsBox>
      <PlayIcon src={playIcon} onClick={hideOptionsModal} cursor="pointer"/>
      <OptionsList>
        <OptionsListItem onClick={props.showHowToPlayModal} cursor="pointer">{t('options.howToPlay')}</OptionsListItem>
        {props.showRecycleInformation && <OptionsListItem onClick={props.showFunFactsModal}  cursor="pointer">{t('options.recyclingInfo')}</OptionsListItem>}
        <OptionsListItem onClick={quitGame}  cursor="pointer">{t('options.quit')}</OptionsListItem>
      </OptionsList>
    </OptionsBox>
  );
};

export default OptionsModal;
